import { StateCreator } from 'zustand';
import { SystemSettings, defaultSystemSettings } from '../../types/system';

export interface SystemSettingsSlice {
  systemSettings: SystemSettings;
  updateSystemSettings: (settings: SystemSettings) => void;
}

export const createSystemSettingsSlice: StateCreator<SystemSettingsSlice> = (set) => ({
  systemSettings: defaultSystemSettings,
  updateSystemSettings: (settings) => set({ systemSettings: settings }),
});